import * as types from "../constants/skillConstants";
const initialState = {
  isLoading: { status: true },
  skills: [],
  my_skills: [],
  draft_skills: [],
  trainDraft: null,
  draftSession: null,
  trainer_record: [],
  current_property_skill: null,
  skillArea: [],
  skill_fields: [],
  searchTerm: null,
  searchSkill: "",
  favoriteSkills: [],
  skillsToFavorite: [],
  helper: null,
  pageInfoSkill: [],
  pageInfoDraft: [],
  helperTask: [],
  userHelper: [],
  isActive: "Create",
  activeCategory: "All",
  createTemplate: null,
  isRecording: {},
  headers: [],
  sortedVar: [],
  toogleDataMapper: false,
  changeView: "isBusinessView",
  advancedConfigPanel: null,
  startTimer: null,
  unsavedChanges: false,
  loading: false,
  skillMeta: null,
  flowVariables: [],
  devices: [],
  variablePanel: false,
  mostPopular: [],
  trending: [],
  allSkillSet: [],
  publishedSkill: [],
  searchMySkill: [],
  publishedCount: 0,
  totalCount: 0,
  searchCount: 0,
  searchFilterdCount: 0,
  searchMetaSkill: [],
  metaSearchCount: 0,
  filteredSkill: [],
  filteredCount: 0,
  filteredSkillSets: [],
  filteredSkillSetCount: 0,
  selectedItem: null,
  readOnly: true,
  chatPanel: null,
  ragPanel: null,
  mySkillSets: [],
  totalSkillSetCount: 0,
  skillSetsByEmail: [],
  countByEmail: 0,
  filteredEmailSkill: [],
  allTemplates: [],
  skillByEmailCount: 0,
  all_skills: [],
  allCount: 0,
  metaByEmail: [],
  metaByEmailCount: 0,
  myMetaSkill: [],
  myMetaCount: 0,
  filteredMetaSkill: [],
  filteredMetaCount: 0,
  processSkill: [],
  compareFlow: [],
  aggregatedFlow: [],
  selectedFilter: "all",
  userEmail: "",
  selectedTemplate: "",
  searchQuery: "",
  searchFilteredSkills: [],
  searchMetaSkills: [],
  metaSearchCountByTemp: 0,
  allVariants: [],
  rpdMetric: {},
  skillId: null,
  isLoadingMetrics: false,
  aiAgentHubData: [],
};
const skillReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.IS_LOADING:
      return { ...state, isLoading: action.payload.status };
    case types.LOADING:
      return { ...state, loading: action.payload };

    case types.CREATE_DRAFT:
      return { ...state, createTemplate: action.payload };

    case types.SAVE_FAVOURITE_SKILLS:
      return Object.assign({}, state, {
        favoriteSkills: [...state.favoriteSkills, action.payload],
      });

    case types.GET_FAVOURITE_SKILLS:
      return Object.assign({}, state, {
        favoriteSkills: [...action.payload],
      });

    case types.REMOVE_FAVOURITE_SKILLS:
      return Object.assign({}, state, {
        favoriteSkills: action.payload,
      });

    case types.GET_MY_SKILLS:
      return Object.assign({}, state, {
        my_skills: action.payload,
      });

    case types.SEARCH_SKILLS:
      return Object.assign({}, state, {
        searchSkill: action.payload,
      });

    case types.GET_SKILLS:
      return { ...state, skills: action.payload };

    case types.GET_DRAFTS:
      return {
        ...state,
        draft_skills: action.payload,
        totalCount: action.totalCount,
      };

    case types.GET_ALL_SKILLS:
      return {
        ...state,
        all_skills: action.payload,
        allCount: action.allCount,
      };

    case types.GET_DRAFTS_BY_ID:
      return {
        ...state,
        trainDraft: action.payload,
        skillMeta: action.skillMeta ? action.skillMeta : null,
        unsavedChanges: false,
        loading: false,
        advancedConfigPanel: null,
      };

    case types.SET_DRAFT:
      return Object.assign({}, state, {
        trainDraft: action.payload,
        unsavedChanges: true,
      });

    case types.SET_ADVANCED_PANEL:
      return Object.assign({}, state, {
        advancedConfigPanel: action.payload,
      });

    case types.CLOSE_ADVANCED_PANEL:
      return Object.assign({}, state, {
        advancedConfigPanel: action.payload,
      });
    case types.SET_VARIABLE_PANEL:
      return { ...state, variablePanel: action.payload };

    case types.CLEAR_DRAFTS:
      return { ...state, trainDraft: [], helper: null };

    case types.START_SKILL_RECORD:
      return {
        ...state,
        draftSession: action.payload,
        devices: action.devices,
      };

    case types.DEVICES:
      return {
        ...state,
        draftSession: action.payload,
        devices: action.devices,
      };

    case types.ADD_TRAINER:
      return { ...state, trainer_record: action.payload };

    case types.OPEN_PANEL:
      return { ...state, current_property_skill: action.payload };

    case types.DISABLE_USER_POPUP:
      return {
        ...state,
        skill_user_screen: false,
        skill_fields: [],
        current_skill: {},
      };

    case types.UPDATE_SKILL_VIEW:
      return { ...state, skillArea: action.payload };

    case types.USER_UPLOAD:
      return {
        ...state,
        skill_user_screen: true,
        skill_fields: action.payload === undefined ? [] : action.payload,
        current_skill: action.item,
      };

    case types.UPDATE_SEARCH_TERM:
      return { ...state, searchTerm: action.payload };
    case types.VIEW_HELPER_ITEM:
      return { ...state, helper: action.payload };
    case types.PAGE_INFO_SKILL:
      return { ...state, pageInfoSkill: action.payload };
    case types.PAGE_INFO_DRAFT:
      return { ...state, pageInfoDraft: action.payload };
    case types.GET_HELPER_TASK:
      return { ...state, helperTask: action.payload };
    case types.GET_USER_HELPER:
      return { ...state, userHelper: action.payload };
    case types.GET_ACTIVE_TAB:
      return { ...state, isActive: action.payload };
    case types.SET_ACTIVE_CATEGORY:
      return { ...state, activeCategory: action.payload };
    case types.UPDATE_DRAFT:
      return { ...state, trainDraft: action.payload, unsavedChanges: false };
    case types.IS_RECORDING:
      return { ...state, isRecording: action.payload };

    case types.GET_SHEET_HEADERS:
      return { ...state, headers: action.payload };
    case types.TOOGLE_DATA_MAPPER:
      return {
        ...state,
        toogleDataMapper: action.payload,
      };
    case types.STAT_CHANGE_FLOW:
      return { ...state, changeView: action.payload };
    case types.SET_TIMER:
      return { ...state, startTimer: action.payload };
    case types.GET_MOST_POPULAR_SKILL:
      return { ...state, mostPopular: action.payload };
    case types.GET_TRENDING_SKILL:
      return { ...state, trending: action.payload };
    case types.GET_ALL_SKILLSET:
      return { ...state, allSkillSet: action.payload };
    case types.SET_SEARCH_SKILL:
      return {
        ...state,
        searchMySkill: action.payload,
        searchCount: action.searchCount,
      };
    case types.SEARCH_METADATA_SKILL:
      return {
        ...state,
        searchMetaSkill: action.payload,
        metaSearchCount: action.metaSearchCount,
      };
    case types.GET_FILTERED_SKILL:
      return {
        ...state,
        filteredSkill: action.payload,
        filteredCount: action.filteredCount,
      };
    case types.GET_META_BYEMAIL:
      return {
        ...state,
        metaByEmail: action.payload,
        metaByEmailCount: action.metaByEmailCount,
      };
    case types.GET_FILTERED_METASKILL:
      return {
        ...state,
        filteredMetaSkill: action.payload,
        filteredMetaCount: action.filteredMetaCount,
      };
    case types.GET_MY_META_SKILL:
      return {
        ...state,
        myMetaSkill: action.payload,
        myMetaCount: action.myMetaCount,
      };
    case types.GET_DRAFT_BYEMAIL:
      return {
        ...state,
        filteredEmailSkill: action.payload,
        skillByEmailCount: action.skillByEmailCount,
      };
    case types.GET_MY_SKILLSET:
      return {
        ...state,
        mySkillSets: action.payload,
        totalSkillSetCount: action.totalSkillSetCount,
      };
    case types.GET_SKILLSET_BY_EMAIL:
      return {
        ...state,
        skillSetsByEmail: action.payload,
        countByEmail: action.countByEmail,
      };
    case types.GET_ALL_TEMPLATES:
      return {
        ...state,
        allTemplates: action.payload,
      };
    case types.SET_SELECTED_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case types.SET_READ_ONLY:
      return { ...state, readOnly: action.payload };
    case types.SET_CHAT_PANEL:
      return { ...state, chatPanel: action.payload };
    case types.SET_RAG_PANEL:
      return { ...state, ragPanel: action.payload };
    case types.GET_FILTERED_SKILLSET:
      return {
        ...state,
        filteredSkillSets: action.payload,
        filteredSkillSetCount: action.filteredSkillSetCount,
      };
    case types.PROCESS_SKILL:
      return {
        ...state,
        processSkill: action.payload,
        count: action.count,
      };

    case types.ADD_TO_COMPARE:
      return {
        ...state,
        compareFlow: action.payload,
      };
    case types.AGGREGATED_RESULT:
      return {
        ...state,
        aggregatedFlow: action.payload,
      };

    case types.SET_SELECTED_FILTER:
      return {
        ...state,
        selectedFilter: action.payload,
      };
    case types.SET_USER_EMAIL:
      return {
        ...state,
        userEmail: action.payload,
      };
    case types.SET_SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload,
      };
    case types.SET_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.payload,
      };
    case types.SET_FILTERED_SKILL:
      return {
        ...state,
        searchFilteredSkills: action.payload,
        searchFilteredCount: action.searchFilteredCount,
      };
    case types.SEARCH_METASKILL_BYTEMPLATE:
      return {
        ...state,
        searchMetaSkills: action.payload,
        metaSearchCountByTemp: action.metaSearchCountByTemp,
      };
    case types.LIST_VARIANTS_DATA:
      return {
        ...state,
        allVariants: action.payload,
      };
    case types.SET_RPD_METRICS:
      return {
        ...state,
        rpdMetric: action.payload,
      };
    case types.LOADING_METRICS:
      return {
        ...state,
        isLoadingMetrics: action.payload,
      };
    case types.SET_SKILL_ID:
      return {
        ...state,
        skillId: action.payload,
      };
    case types.SET_DATE_FILTER:
      return { ...state, selectedDate: action.payload };
    case types.AI_AGENT_HUB_DATA:
      return { ...state, aiAgentHubData: action.payload };
    default:
      return state;
  }
};

export default skillReducer;
